import React from "react";

function Proride() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Proride</h1>
        <p className="text-gray-700 leading-relaxed text-base">
          <strong>Proride</strong> is the renowned brand of Dhanoa, a
          distinguished bicycle parts manufacturer in India, established in
          1986. Proride products are crafted with a blend of modern management,
          human touch, sheer hard work, dedication, and a strong commitment to
          producing quality products that ensure ultimate consumer satisfaction.
        </p>
      </div>

      {/* Core Values */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Core Values and Practices
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
          <li>
            <strong className="text-gray-900">Expert Design:</strong> Talented
            professionals precisely design Proride products using optimal
            methodologies, adhering to stringent quality standards.
          </li>
          <li>
            <strong className="text-gray-900">Customer Focus:</strong> These
            professionals are sincere and cordial, ensuring optimal satisfaction
            for esteemed clients.
          </li>
          <li>
            <strong className="text-gray-900">Top-Notch Quality:</strong>{" "}
            Proride products are designed with a deep understanding of cyclists'
            needs, ensuring they are of the highest quality.
          </li>
          <li>
            <strong className="text-gray-900">Chemical-Free:</strong> Products
            are free from harsh chemicals, ensuring safety and durability.
          </li>
          <li>
            <strong className="text-gray-900">Affordable Pricing:</strong>{" "}
            High-quality products are offered at affordable prices, making them
            accessible to a wide range of cyclists.
          </li>
          <li>
            <strong className="text-gray-900">Collaboration:</strong> Proride is
            working closely with Cyclecircle to introduce more advanced products
            at affordable prices in India.
          </li>
        </ul>
      </div>

      {/* Closing Note */}
      <div className="max-sm:px-4">
        <p className="text-gray-700 text-sm leading-relaxed">
          Proride by Dhanoa is dedicated to delivering superior bicycle parts
          that meet the evolving needs of cyclists, combining innovation with
          affordability for the ultimate cycling experience.
        </p>
      </div>
    </div>
  );
}

export default Proride;
